__webpack_require__.p = "/assets/turbo/8864d55f/universalat/_next/";